import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  Tabs,
  Tab,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import TabPanel from "../../component/TabPanel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  deletePurchase,
  getPurchaseById,
  updatePurchase,
} from "../../api/purchase";
import { handleAxiosError } from "../../config/action-config";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import { orderItemsTable } from "../../config/grid-columns-defs";
import { getLowestLevelTask } from "../../api/project";
import { createItem, deleteItem, updateItem } from "../../api/orderItem";
import { showAlert } from "../../actions/alert";
import { DesktopDatePicker } from "@mui/x-date-pickers";

const deleteApis = {
  "PURCHASE-ORDER": deletePurchase,
  ITEM: deleteItem,
};

const emptyPurchaseData = {
  creation_date: "",
  delivery_date: "",
  payment_terms: "",
  po_amount: "",
  po_date: "",
  po_description: "",
  po_number: "",
  project_id: "",
  shipping_address: "",
  vendor_id: "",
  id: "",
};

export default function ViewPurchase() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rowHeight = 38;

  const [loading, setLoading] = useState(true);
  const [purchaseData, setPurchaseData] = useState(emptyPurchaseData);

  const [tabIndex, setTabIndex] = useState(0);

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);

  const [orderItems, setOrderItems] = useState([]);
  const loadMasterData = () => {
    getPurchaseById(params.id, user.token)
      .then((res) => {
        setPurchaseData(res.data.data.order);
        setOrderItems(res.data.data.items);
        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const onOrderDataUpdate = () => {
    console.log("last---", purchaseData);
    purchaseData.delivery_date = createDateAsUTC(purchaseData.delivery_date);
    purchaseData.po_date = createDateAsUTC(purchaseData.po_date);

    updatePurchase(
      purchaseData.id,
      getUpdatablePurchaseData(purchaseData),
      user.token
    )
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setEditDisabled(true);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else loadMasterData();
  }, [params.id]);

  const changeUpdateData = (e) => {
    setPurchaseData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const [itemDialog, setItemDialog] = useState({ open: false, mode: "CREATE" });
  const [selectedItemRow, setSelectedItemRow] = useState(0);
  const onItemDialogSubmit = async (data) => {
    try {
      let res = {};
      if (itemDialog.mode === "CREATE") {
        res = await createItem({ ...data, po_id: purchaseData.id }, user.token);
      } else if (itemDialog.mode === "UPDATE") {
        res = await updateItem(
          selectedItemRow,
          { ...getUpdatableOrderItemData(data), po_id: purchaseData.id },
          user.token
        );
      }
      loadMasterData();
      dispatch(showAlert(res.data.msg));
      setSelectedItemRow(0);
      setItemDialog({ open: false, mode: "" });
    } catch (error) {
      setItemDialog({ open: false, mode: "" });
      handleAxiosError(error, dispatch);
    }
  };

  const onDelete = async () => {
    try {
      const deleteApi = deleteApis[deletingContent.table];
      const res = await deleteApi(deletingContent.row, user.token);
      dispatch(showAlert(res.data.msg));
      setDeletingContent({ type: "", row: 0 });
      if (deletingContent.table === "PURCHASE-ORDER") {
        navigate("/purchase-orders");
      } else if (deletingContent.table === "ITEM") {
        loadMasterData();
      }
    } catch (error) {
      setDeletingContent({ table: "", row: 0 });
      handleAxiosError(error, dispatch);
    }
  };

  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Purchase Order Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
              className="cancel-button"
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({
                  table: "PURCHASE-ORDER",
                  row: purchaseData.id,
                });
              }}
              className="blue-button"
            >
              Delete
            </Button>
          </Box>
        </Box>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onOrderDataUpdate();
          }}
        >
          <Grid container spacing={2} sx={{ pt: "1rem" }}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                required
                margin="dense"
                name="po_number"
                size="small"
                fullWidth
                value={purchaseData.po_number}
                onChange={() => {}}
                label="PO Number"
                type="text"
                variant="outlined"
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                required
                margin="dense"
                name="po_amount"
                size="small"
                fullWidth
                value={purchaseData.po_amount}
                onChange={changeUpdateData}
                label="Order Amount"
                type="number"
                variant="outlined"
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                required
                margin="dense"
                name="payment_terms"
                size="small"
                fullWidth
                value={purchaseData.payment_terms}
                onChange={changeUpdateData}
                label="Payment Terms"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <TextField
                required
                margin="dense"
                name="shipping_address"
                size="small"
                fullWidth
                value={purchaseData.shipping_address}
                onChange={changeUpdateData}
                label="Shipping Address"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <TextField
                required
                margin="dense"
                name="po_description"
                size="small"
                fullWidth
                value={purchaseData.po_description}
                onChange={changeUpdateData}
                label="Order Description"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Order Date"
                  value={purchaseData.po_date}
                  disabled={editDisabled}
                  onChange={(newValue) => {
                    changeUpdateData({
                      target: { name: "po_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth required size="small" />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Delivery Date"
                  value={purchaseData.delivery_date}
                  disabled={editDisabled}
                  onChange={(newValue) => {
                    changeUpdateData({
                      target: { name: "delivery_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth required size="small" />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <LocalizationProvider required dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Creation Date"
                  value={purchaseData.creation_date}
                  disabled={true}
                  onChange={() => {}}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                required
                margin="dense"
                name="project_id"
                size="small"
                fullWidth
                value={purchaseData.project_name}
                onChange={changeUpdateData}
                label="Project"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                required
                margin="dense"
                name="vendor_id"
                size="small"
                fullWidth
                value={purchaseData.vendor_name}
                onChange={changeUpdateData}
                label="Vendor"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              {editDisabled ? (
                <></>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    columnGap: 1,
                    ml: "auto",
                  }}
                >
                  <Button
                    disabled={/^Trial_User$/i.test(user.role) ? true : false}
                    variant="contained"
                    type="submit"
                    // onClick={onOrderDataUpdate}
                    style={{ padding: "5px 7px" }}
                    className="blue-button"
                  >
                    Update
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
        </form>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Order Items"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
            <Button
              variant="contained"
              style={{ padding: "5px 7px" }}
              onClick={() => {
                setItemDialog({ open: true, mode: "CREATE" });
              }}
              className="blue-button"
            >
              Add Item
            </Button>
            {Boolean(selectedItemRow) ? (
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                onClick={() => {
                  setItemDialog({ open: true, mode: "UPDATE" });
                }}
                className="blue-button"
              >
                Update Selected
              </Button>
            ) : (
              <></>
            )}
            {Boolean(selectedItemRow) ? (
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                onClick={() => {
                  setDeletingContent({ table: "ITEM", row: selectedItemRow });
                }}
                className="blue-button"
              >
                Delete Selected
              </Button>
            ) : (
              <></>
            )}
          </Box>
          <div className="ag-theme-material pmt-controll-table">
            <AgGridReact
              columnDefs={orderItemsTable}
              rowData={orderItems}
              rowSelection="single"
              onRowClicked={(params) => {
                setSelectedItemRow(params.data.id);
              }}
              domLayout="autoHeight"
              headerHeight="38"
              rowHeight={rowHeight}
              defaultColDef={{
                resizable: true,
                flex: 1,
              }}
            />
          </div>
        </Paper>
      </TabPanel>
      <ItemDialog
        open={itemDialog.open}
        setOpen={setItemDialog}
        itemData={orderItems.find((o) => o.id === selectedItemRow)}
        onSubmit={onItemDialogSubmit}
        token={user.token}
        project_id={purchaseData.project_id}
        mode={itemDialog.mode}
      />
      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

const emptyItemData = {
  item_name: "",
  item_description: "",
  item_price: "",
  quantity: "",
  discount_percentage: "",
  tax_percentage: "",
  task_id: "",
};
function ItemDialog({
  open,
  setOpen,
  onSubmit,
  itemData,
  mode = "CREATE",
  token,
  project_id,
}) {
  const [data, setData] = useState(emptyItemData);
  const user = useSelector((state) => state.user);
  useEffect(() => {
    if (itemData?.id) {
      setData(itemData);
    }
  }, [itemData?.id]);

  useEffect(() => {
    if (mode === "CREATE") setData(emptyItemData);
  }, [mode]);
  const dispatch = useDispatch();
  const [taskList, setTaskList] = useState([]);
  const [taskDisabled, setTaskDisabled] = useState(true);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (!project_id) return;
    setTaskDisabled(true);
    getLowestLevelTask(project_id, token, false)
      .then((res) => {
        setTaskList(res.data.data);
        setTaskDisabled(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  }, [project_id]);

  const submit = () => {
    onSubmit(data);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen({ open: false, mode: "" });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textTransform: "capitalize" }}
        >
          {mode} Order Item
        </DialogTitle>
        <DialogContent>
          <Grid container width={500} spacing={1} py={1}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label-taks">Task</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label-task"
                  id="demo-simple-select-task"
                  value={data.task_id}
                  label="Task"
                  name="task_id"
                  disabled={taskDisabled || !taskList.length}
                  onChange={handleChange}
                >
                  {taskList.map((t, i) => (
                    <MenuItem key={i} value={t.id}>
                      {t.task_code} - {t.task_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                type="text"
                onChange={handleChange}
                value={data.item_name}
                label="Name"
                className="name-textfeild"
                name="item_name"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                type="text"
                onChange={handleChange}
                value={data.item_description}
                label="Description"
                name="item_description"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                type="number"
                onChange={handleChange}
                value={data.item_price}
                label="Price"
                name="item_price"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                type="number"
                onChange={handleChange}
                value={data.tax_percentage}
                label="Tax %"
                name="tax_percentage"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                type="number"
                onChange={handleChange}
                value={data.discount_percentage}
                label="Discount %"
                name="discount_percentage"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                type="number"
                onChange={handleChange}
                value={data.quantity}
                label="Quantity"
                name="quantity"
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            className="cancel-button"
            onClick={() => {
              setOpen({ open: false, mode: "" });
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            type="submit"
            className="blue-button"
          >
            {mode}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  const user = useSelector((state) => state.user);
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          onClick={onDelete}
          className="blue-button"
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatablePurchaseData(data) {
  console.log("---", data);
  return {
    delivery_date: data.delivery_date,
    payment_terms: data.payment_terms,
    po_amount: data.po_amount,
    po_date: data.po_date,
    po_description: data.po_description,
    project_id: data.project_id,
    shipping_address: data.shipping_address,
    vendor_id: data.vendor_id,
  };
}

function getUpdatableOrderItemData(data) {
  return {
    item_name: data.item_name,
    item_description: data.item_description,
    item_price: data.item_price,
    quantity: data.quantity,
    discount_percentage: data.discount_percentage,
    tax_percentage: data.tax_percentage,
    task_id: data.task_id,
  };
}
function createDateAsUTC(date) {
  console.log("----create", date);
  if (date === null) {
    return "";
  }
  date = new Date(date);
  // If the 'date' parameter is not provided or is blank, return an empty string
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return null;
  } else {
    const year = date.getFullYear();
    return new Date(
      Date.UTC(
        year,
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  // Proceed with the rest of the code
}
